<div class="c-icon" [ngClass]="'c-icon--' + size" [class.c-icon--black]="color === 'black'"
  [class.c-icon--red]="color === 'red'" [class.c-icon--green]="color === 'green'"
  [class.c-icon--loading]="loading" [class.c-icon--custom]="customColor"
  [style.backgroundColor]="customColor">
  <ion-icon *ngIf="name; else useImg" [name]="name"></ion-icon>
  <ng-template #useImg>
    <img *ngIf="src || default" [src]="src || default" (error)="setDefaultImage(this)">
  </ng-template>
</div>